import { redirect, type LoaderFunctionArgs } from 'react-router';

import { getAccountDetailsFromURL } from '~/utils/utils';

import { perms } from './perms';
import { sessionContext } from './sessionContext';

type PermFunction = (typeof perms)[keyof typeof perms];

/**
 * Permission-only loader. Expects `resolveSessionMiddleware` (or staff
 * equivalent) to have already set `sessionContext` for this navigation.
 */
export function requirePerm(perm: PermFunction) {
  return ({ context, request }: LoaderFunctionArgs) => {
    const sessionPlData = context.get(sessionContext);
    if (perm({ sessionPlData })) {
      return sessionPlData;
    }

    const url = new URL(request.url);
    const { accountType, accountId } = getAccountDetailsFromURL(url.pathname) ?? {};
    if (accountType && accountId) {
      throw redirect(`/${accountType}/${accountId}/forbidden`);
    }
    throw redirect('/forbidden');
  };
}
